// react
import React from 'react'
import { useState } from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

// Styles
import './styles.scss'

import { ENTITY } from './constants'

const TTDHealthAudiences = () => {
  const [modalOpen, setModalOpen] = useState(false)

  const toggleModal = () => {
    setModalOpen(!modalOpen)
  }

  return (
    <div id="ttd-health-audiences-page" className="ttd-health-audiences">
      <Header
        title="TTD Health Audiences"
        actions={[
          {
            children: 'Create New TTD Health Audience',
            onClick: toggleModal,
          },
        ]}
      />

      <ListView
        columns={[
          {
            name: 'Condition',
            key: 'condition',
            sortable: true,
            width: 200,
          },
          {
            name: 'Name',
            key: 'name',
            link: `/${ENTITY}/:_id`,
            sortable: true,
            width: 700,
            styles: {
              textAlign: 'left',
            },
          },
          {
            key: 'created_at',
            name: 'Created At',
          },
        ]}
        entities={ENTITY}
        fields={['condition', 'name', 'created_at']}
        searchable={true}
        sort_dir={1}
        sort_key={'name'}
      />
      <If condition={modalOpen}>
        <Dialog close={toggleModal} open={modalOpen}>
          <NewEntityDialog close={toggleModal} entities={ENTITY} title="Please enter a name" />
        </Dialog>
      </If>
    </div>
  )
}

// export
export default TTDHealthAudiences
